<template>
  <div class="box17">
    <pageTitle title="常见问题" text />

    <commomProblem :problemData="problemData" :styleData="styleData" />
    <div class="btn" @click="zixun('了解更多')">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "人工智能与Python语言是什么区别？",
          answer: [
            "学人工智能也相当于写人工智能程序，和学习别语言和就业方向是一样的。目前写人工智能程序的第一编程语言是Python，所以在人工智能课程中我们会讲Python编程。Python语言是一个编程工具。我们学会以后就快速转到人工智能行业中做开发了。",
          ],
        },
        {
          title: "数学基础不好能报人工智能嘛？报人工智能课程对数学有什么要求？",
          answer: [
            "对数学没有特殊要求，一般大学中所学数学是足够用的。如果用到数学，在课程中会给学生补充的。",
          ],
        },
        // {
        //   title: "若学了人工智能课程，同时也喜欢爬虫、Python Web开发怎么办？",
        //   answer: [
        //     "博学谷提供职业拓展课，继续进行职业拓展，比如在爬虫、Web方面。",
        //   ],
        // },
        {
          title: "为什么学完就能就业？",
          answer: [
            "博学谷课程有30多个案例、3个项目，同时还赠送人工智能职业拓展课（里面有4个项目）。有一点需要提醒，有些培训机构的项目，其实在我们这里只是案例。人工智能项目里面训练了学生两个能力（1.职业拓展能力2.AI业务流的搭建能力），一个项目讲上6天到8天，很大程度上增加了学生的业务经验。",
          ],
        },
        {
          title: "如何保障学生就业？",
          answer: [
            "一站式流程就业服务，就业指导老师进行简历指导+模拟面试+技术导师项目指导， 并通过就业课程，分享学习方法、求职经验等，让你实时了解行业动态，助你高薪就业。",
          ],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/ai/box17/question.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("人工智能开发-AI就业课","了解更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box17 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box17/bg.png") no-repeat;
  background-size: cover;

  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(270deg, #1fd7cd 0%, #65adff 100%);
    box-shadow: 0px 4px 12px 0px rgba(64, 128, 255, 0.12);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    line-height: 96px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
